import { useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import "./ActivityData.scss"

import C1ConditionsOfExemption from "./C1ConditionsOfExemption/C1CondiitonsOfExemption";
import C22FuelBunkered from "./C22FuelBunkered/C22FuelBunkered";
import C23BunkeringQuantity from "./C23BunkeringQuantity/C23BunkeringQuantity";
import C25Measurements from "./C25Measurements/C25Measurements";
import C21GreenhouseEmissions from "./C21GreenhouseEmissions/C21GreenhouseEmissions";
import C24InstrumentsInvolved from "./C24InstrumentsInvolved/C24InstrumentsInvolved";
import C3ListOfVoyages from "./C3ListOfVoyages/C3ListOfVoyages";
import C4DistanceTravelled from "./C4DistanceTravelled/C4DistanceTravelled";
import C5CargoAndPassengers from "./C5CargoAndPassengers/C5CargoAndPassengers";
import C26DeterminationOfDensity from "./C26DeterminationOfDensity/C26DeterminationOfDensity";
import C27UncertainityLevel from "./C27UncertainityLevel/C27UncertainityLevel";
import C28QualityAssurance from "./C28QualityAssurance/C28QualityAssurance";
import C29FuelConsumptionSplit from "./C29FuelConsumptionSplit/C29FuelConsumptionSplit";
import C210LadenVoyagesFuelConsumption from "./C210LadenVoyagesFuelConsumption/C210LadenVoyagesFuelConsumption";
import C211CargoHeatingFuelConsumption from "./C211CargoHeatingFuelConsumption/C211CargoHeatingFuelConsumption";
import C212DynamicPositioningFuelConsumption from "./C212DynamicPositioningFuelConsumption/C212DynamicPositioningFuelConsumption";
import C6TimeSpentAtSea from "./C6TimeSpentAtSea/C6TimeSpentAtSea";
import C213BallastVoyagesFuelConsumption from "./C213BallastVoyagesFuelConsumption/C213BallastVoyagesFuelConsumption";

const ActivityData = ({ data, refetchMonitoringData, dropdownData, b1Data, vesselMstId}) => {
    const [expandedMainPanel, setExpandedMainPanel] = useState('panel1');
    const [expandedChild, setExpandedChild] = useState(null);

    const renderTitleWithIcon = (panel, title) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {expandedMainPanel === panel || expandedChild === panel ? '−' : '+'}
            </span>
            <p className="fuel-cons">{title}</p>
        </div>
    );

    const autoSaveForC1 = useRef();
    const autoSaveForC2 = useRef();
    const autoSaveForC21 = useRef();
    const autoSaveForC22 = useRef();
    const autoSaveForC23 = useRef();
    const autoSaveForC24 = useRef();
    const autoSaveForC25 = useRef();
    const autoSaveForC26 = useRef();
    const autoSaveForC27 = useRef();
    const autoSaveForC28 = useRef();
    const autoSaveForC29 = useRef();
    const autoSaveForC210 = useRef();
    const autoSaveForC211 = useRef();
    const autoSaveForC212 = useRef();
    const autoSaveForC213 = useRef();
    const autoSaveForC3 = useRef();
    const autoSaveForC4 = useRef();
    const autoSaveForC5 = useRef();
    const autoSaveForC6 = useRef();

    const handleMainChange = (panel) => async (_, isExpanded) => {
        let isSubmitSuccess = true;
        if (expandedMainPanel === 'panel1' && autoSaveForC1.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC1.current.submitAndCheck();
        } else if (expandedMainPanel === 'panel2' && autoSaveForC2.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC2.current.submitAndCheck();
        } else if (expandedMainPanel === 'panel3' && autoSaveForC3.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC3.current.submitAndCheck();
        } else if (expandedMainPanel === 'panel4' && autoSaveForC4.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC4.current.submitAndCheck();
        } else if (expandedMainPanel === 'panel5' && autoSaveForC5.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC5.current.submitAndCheck();
        } else if (expandedMainPanel === 'panel6' && autoSaveForC6.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC6.current.submitAndCheck();
        }
        if (!isSubmitSuccess) return;
        if (expandedChild === 'panel2.1' && autoSaveForC21?.current?.submitAndCheck) {
            const isValid = await autoSaveForC21.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.2' && autoSaveForC22?.current?.submitAndCheck) {
            const isValid = await autoSaveForC22.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.3' && autoSaveForC23?.current?.submitAndCheck) {
            const isValid = await autoSaveForC23.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.4' && autoSaveForC24?.current?.submitAndCheck) {
            const isValid = await autoSaveForC24.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.5' && autoSaveForC25?.current?.submitAndCheck) {
            const isValid = await autoSaveForC25.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.6' && autoSaveForC26?.current?.submitAndCheck) {
            const isValid = await autoSaveForC26.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.7' && autoSaveForC27?.current?.submitAndCheck) {
            const isValid = await autoSaveForC27.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.8' && autoSaveForC28?.current?.submitAndCheck) {
            const isValid = await autoSaveForC28.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.9' && autoSaveForC29?.current?.submitAndCheck) {
            const isValid = await autoSaveForC29.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.10' && autoSaveForC210?.current?.submitAndCheck) {
            const isValid = await autoSaveForC210.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.11' && autoSaveForC211?.current?.submitAndCheck) {
            const isValid = await autoSaveForC211.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.12' && autoSaveForC212?.current?.submitAndCheck) {
            const isValid = await autoSaveForC212.current.submitAndCheck();
            if (!isValid) return;
        } else if (expandedChild === 'panel2.13' && autoSaveForC213?.current?.submitAndCheck) {
            const isValid = await autoSaveForC213.current.submitAndCheck();
            if (!isValid) return;
        }
        setExpandedMainPanel(isExpanded ? panel : false);
        if (panel === 'parentPanel') {
            setExpandedChild(null);
        }
    };

    const handleChildChange = (panel) => async (_, isExpanded) => {
        let isSubmitSuccess = true;
        if (expandedChild === 'panel2.1' && autoSaveForC21.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC21.current.submitAndCheck();
        } else if (expandedChild === 'panel2.2' && autoSaveForC22.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC22.current.submitAndCheck();
        } else if (expandedChild === 'panel2.3' && autoSaveForC23.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC23.current.submitAndCheck();
        } else if (expandedChild === 'panel2.4' && autoSaveForC24.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC24.current.submitAndCheck();
        } else if (expandedChild === 'panel2.5' && autoSaveForC25.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC25.current.submitAndCheck();
        } else if (expandedChild === 'panel2.6' && autoSaveForC26.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC26.current.submitAndCheck();
        } else if (expandedChild === 'panel2.7' && autoSaveForC27.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC27.current.submitAndCheck();
        } else if (expandedChild === 'panel2.8' && autoSaveForC28.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC28.current.submitAndCheck();
        } else if (expandedChild === 'panel2.9' && autoSaveForC29.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC29.current.submitAndCheck();
        } else if (expandedChild === 'panel2.10' && autoSaveForC210.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC210.current.submitAndCheck();
        } else if (expandedChild === 'panel2.11' && autoSaveForC211.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC211.current.submitAndCheck();
        } else if (expandedChild === 'panel2.12' && autoSaveForC212.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC212.current.submitAndCheck();
        } else if (expandedChild === 'panel2.13' && autoSaveForC213.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForC213.current.submitAndCheck();
        }
        if (!isSubmitSuccess) return;
        setExpandedChild(isExpanded ? panel : null);
    };

    const methods = useForm({
        mode: 'onBlur',
        defaultValues: {
        },
    });

    return (
        <FormProvider {...methods}>
            <form className="activity-data">
                <Accordion expanded={expandedMainPanel === 'panel1'} onChange={handleMainChange('panel1')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel1', 'C.1 Conditions of exemption related to Article 9(2) of Regulation (EU) 2015/757')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <C1ConditionsOfExemption ref={autoSaveForC1} vesselMstId={vesselMstId} c1ExemptionConditionsData={data?.c1ExemptionConditions} refetchMonitoringData={refetchMonitoringData} dropdownData={dropdownData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedMainPanel === 'parentPanel'} onChange={handleMainChange('parentPanel')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('parentPanel', 'C.2 Monitoring of greenhouse gas emissions and fuel consumption')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <Accordion expanded={expandedChild === 'panel2.1'} onChange={handleChildChange('panel2.1')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.1', 'C.2.1 Methods used to determine greenhouse gas emissions and fuel consumption of each emission source:')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C21GreenhouseEmissions ref={autoSaveForC21} vesselMstId={vesselMstId} c21GhgEmissions={data?.c21GhgEmissions} refetchMonitoringData={refetchMonitoringData} dropdownData={dropdownData} shouldRefetch={expandedChild === 'panel2.1'} />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expandedChild === 'panel2.2'} onChange={handleChildChange('panel2.2')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.2', 'C.2.2 Procedures for determining fuel bunkered and fuel in tanks:')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C22FuelBunkered ref={autoSaveForC22} vesselMstId={vesselMstId} c22FuelTanks={data?.c22FuelTanks} refetchMonitoringData={refetchMonitoringData} />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expandedChild === 'panel2.3'} onChange={handleChildChange('panel2.3')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.3', 'C.2.3 Regular cross-checks between bunkering quantity as provided by BDN and bunkering quantity indicated by on-board measurement:')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C23BunkeringQuantity ref={autoSaveForC23} vesselMstId={vesselMstId} c23Bunkering={data?.c23Bunkering} refetchMonitoringData={refetchMonitoringData} />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expandedChild === 'panel2.4'} onChange={handleChildChange('panel2.4')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.4', 'C.2.4 Description of the measurement instruments involved:')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C24InstrumentsInvolved ref={autoSaveForC24} vesselMstId={vesselMstId} c24InstrumentMeasurement={data?.c24InstrumentMeasurement} refetchMonitoringData={refetchMonitoringData} dropdownData={dropdownData} />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expandedChild === 'panel2.5'} onChange={handleChildChange('panel2.5')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.5', 'C.2.5 Procedures for recording, retrieving, transmitting and storing information regarding measurements:')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C25Measurements ref={autoSaveForC25} vesselMstId={vesselMstId} c25RegardingMeasurements={data?.c25RegardingMeasurements} refetchMonitoringData={refetchMonitoringData} />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expandedChild === 'panel2.6'} onChange={handleChildChange('panel2.6')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.6', 'C.2.6 Method for determination of density:')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C26DeterminationOfDensity ref={autoSaveForC26} vesselMstId={vesselMstId} c26MethodForDensity={data?.c26MethodForDensity} refetchMonitoringData={refetchMonitoringData} dropdownData={dropdownData} shouldRefetch={expandedChild === 'panel2.6'} />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expandedChild === 'panel2.7'} onChange={handleChildChange('panel2.7')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.7', 'C.2.7. Level of uncertainty associated with fuel monitoring:')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C27UncertainityLevel
                                    c27LevelOfUncertainity={data?.c27LevelOfUncertainity}
                                    vesselMstId={vesselMstId}
                                    refetchMonitoringData={refetchMonitoringData}
                                    shouldRefetch={expandedChild === 'panel2.7'}
                                    levelOfUncertainities={dropdownData?.levelOfUncertainities}
                                    ref={autoSaveForC27}
                                    monitoringMethods={dropdownData?.monitoringMethodOptions}
                                />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expandedChild === 'panel2.8'} onChange={handleChildChange('panel2.8')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.8', 'C.2.8 Procedures for ensuring quality assurance of measuring equipment:')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C28QualityAssurance
                                    ref={autoSaveForC28}
                                    vesselMstId={vesselMstId}
                                    c28QualityAsuranceEquipment={data?.c28QualityAsuranceEquipment}
                                    refetchMonitoringData={refetchMonitoringData} />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={b1Data?.shipType === "ROPAX" && expandedChild === 'panel2.9'} onChange={handleChildChange('panel2.9')} className="mt-3">
                            <AccordionSummary className={b1Data?.shipType === "ROPAX" ? "accordion-header" : "accordion-opacity"}>
                                {renderTitleWithIcon('panel2.9', 'C.2.9 Method for determining the split of fuel consumption into freight and passenger part (for ro-pax ships only):')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C29FuelConsumptionSplit
                                    ref={autoSaveForC29}
                                    vesselMstId={vesselMstId}
                                    c29FuelSplitMethod={data?.c29FuelSplitMethod}
                                    refetchMonitoringData={refetchMonitoringData}
                                    allocationMethods={dropdownData?.allocationMethods}
                                />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expandedChild === 'panel2.10'} onChange={handleChildChange('panel2.10')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.10', 'C.2.10 Procedures for determining and recording the fuel consumption on laden voyages (voluntary monitoring):')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C210LadenVoyagesFuelConsumption
                                    c210FuelConsOnLadenVoyages={data?.c210FuelConsOnLadenVoyages}
                                    vesselMstId={vesselMstId}
                                    refetchMonitoringData={refetchMonitoringData}
                                    ref={autoSaveForC210}
                                />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={b1Data?.shipType === "CHEM" && expandedChild === 'panel2.11'} onChange={handleChildChange('panel2.11')} className="mt-3">
                            <AccordionSummary className={b1Data?.shipType === "CHEM" ? "accordion-header" : "accordion-opacity"}>
                                {renderTitleWithIcon('panel2.11', 'C.2.11 Procedures for determining and recording the fuel consumption for cargo heating (voluntary monitoring for chemical tankers):')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C211CargoHeatingFuelConsumption
                                    c211CargoHeating={data?.c211CargoHeating}
                                    vesselMstId={vesselMstId}
                                    refetchMonitoringData={refetchMonitoringData}
                                    ref={autoSaveForC211}
                                />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={(b1Data?.shipType === "OIL" || b1Data?.shipType === "OTHER") && expandedChild === 'panel2.12'} onChange={handleChildChange('panel2.12')} className="mt-3">
                            <AccordionSummary className={b1Data?.shipType === "OIL" || b1Data?.shipType === "OTHER" ? "accordion-header" : "accordion-opacity"}>
                                {renderTitleWithIcon('panel2.12', 'C.2.12 Procedures for determining and recording the fuel consumption for dynamic positioning (voluntary monitoring for oil tankers and ‘other ship types’):')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C212DynamicPositioningFuelConsumption
                                    c212DynamicPositioning={data?.c212DynamicPositioning}
                                    refetchMonitoringData={refetchMonitoringData}
                                    vesselMstId={vesselMstId}
                                    ref={autoSaveForC212}
                                />
                            </AccordionDetails>
                        </Accordion>

                        <Accordion expanded={expandedChild === 'panel2.13'} onChange={handleChildChange('panel2.13')} className="mt-3">
                            <AccordionSummary className="accordion-header">
                                {renderTitleWithIcon('panel2.13', 'C.2.13 Procedures for determining and recording the fuel consumption on ballast voyages:')}
                            </AccordionSummary>
                            <AccordionDetails>
                                <C213BallastVoyagesFuelConsumption
                                    c213FuelConsumptionOnBallast={data?.c213FuelConsumptionOnBallast}
                                    refetchMonitoringData={refetchMonitoringData}
                                    vesselMstId={vesselMstId}
                                    ref={autoSaveForC213}
                                />
                            </AccordionDetails>
                        </Accordion>
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedMainPanel === 'panel3'} onChange={handleMainChange('panel3')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel3', 'C.3 List of voyages')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <C3ListOfVoyages ref={autoSaveForC3} c3VoyagesList={data?.c3VoyagesList} vesselMstId={vesselMstId} refetchMonitoringData={refetchMonitoringData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedMainPanel === 'panel4'} onChange={handleMainChange('panel4')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel4', 'C.4 Distance travelled')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <C4DistanceTravelled ref={autoSaveForC4} vesselMstId={vesselMstId} c41DistanceTravelled={data?.c41DistanceTravelled} c42DistanceTravelledInIce={data?.c42DistanceTravelledInIce} refetchMonitoringData={refetchMonitoringData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedMainPanel === 'panel5'} onChange={handleMainChange('panel5')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel5', 'C.5 Amount of cargo carried and number of passengers')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <C5CargoAndPassengers ref={autoSaveForC5} vesselMstId={vesselMstId} c51CargoAndPassenger={data?.c51CargoAndPassenger} c52CargoDensity={data?.c52CargoDensity} refetchMonitoringData={refetchMonitoringData} b1shipdetails={b1Data} dropdownData={dropdownData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedMainPanel === 'panel6'} onChange={handleMainChange('panel6')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel6', 'C.6 Time spent at sea')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <C6TimeSpentAtSea
                            c61TimeAtSea={data?.c61TimeAtSea}
                            vesselMstId={vesselMstId}
                            c62IceNavigationTime={data?.c62IceNavigationTime}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForC6}
                        />
                    </AccordionDetails>
                </Accordion>
            </form>
        </FormProvider>
    );
};

export default ActivityData;
